import { styled } from '@mui/system';
import { Button } from '@mui/material';

export const AuthButton = styled(Button)({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 16px',
    gap: '8px', // Espacio entre ícono y texto
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '16px',
    borderRadius: '12px',
    color: '#000000',
    backgroundColor: '#ffffff',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06)',
    transition: 'all 0.3s ease-in-out',

    '&:hover': {
        backgroundColor: '#f0f0f0',
        color: '#000000',
        boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.15), 0px 2px 4px rgba(0, 0, 0, 0.1)',
        transform: 'translateY(-2px)',
    },

    //(accesibilidad)
    '&:focus': {
        outline: '2px solid #4285F4',
        outlineOffset: '2px',
    },


    '&:active': {
        boxShadow: 'none',
        transform: 'translateY(0)',
    },

    '&.Mui-disabled': {
        backgroundColor: '#e0e0e0',
        color: '#a0a0a0',
        boxShadow: 'none',
        cursor: 'not-allowed',
    },

    '@media (max-width: 600px)': {
        padding: '10px 12px',
        fontSize: '14px',
    },
});